export default __webpack_public_path__ + "static/media/Lluvia_moderada_a_fuerte.602d8963.svg";